import { defineStore } from 'pinia'
import state from '@/stores/auth/state'
import actionsStore from '@/stores/auth/actions'
import gettersStore from '@/stores/auth/getters'
import mutationsStore from '@/stores/auth/mutations'

export const useAuthStore = defineStore('auth', () => {
  const getters = gettersStore(state)
  const mutations = mutationsStore(state)
  const actions = actionsStore(mutations)
  return {
    state,
    getters,
    mutations,
    actions,
  }
})
